<button class="button" [class.disabled]=disabled() [class.light]=light() [class.dark]=dark() [disabled]=disabled() (click)=clicked.emit()>
    @if (icon(); as icon) {
        <i [class]="'far fa-' + icon"></i>
    }
    <ng-content></ng-content>
    {{text()}}
</button>
